export default ({ request }) => ({
  ecomShipmentBookingListApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/list',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentBookingDetailApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/detail',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentBookingSaveApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/save',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentBookingDelApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/del',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentBookingAppendApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/append',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentBookingContainerOptionsApi(data = {}) {
    return request({
      url: '/ecom/shipment/booking/container/options',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
})
